import flower from "../../../assets/images/flower.png";
import "./Maintenance.css";

export const Maintenance = () => (
  <main className="maintenance">
    <title>Технические работы — MIYUKON</title>
    <meta
      name="description"
      content="На сайте идут технические работы."
    />
    <section className="maintenance-content" aria-labelledby="maintenance-title">
      <img className="maintenance-flower" src={flower} alt="" />
      <h1 id="maintenance-title">На сайте идут<br />технические работы</h1>
    </section>
  </main>
);
